document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_ProductDescriptionDrawer', () => {
    return {
      init() {
        // Register the modal
        Alpine.store('modals').register('product-description', 'rightDrawer');
        
        // Initialize teleport after a short delay to ensure right-drawer-slot exists
        setTimeout(() => {
          initTeleport(this.$root);
        }, 100);
      },
    };
  });
});